import mainProduct from './mainProduct';
import mainProductCartButton from './mainProductCartButton';
// mainProductSpFixedFooter.ts は削除済み（kd-sp-fixed-footer Litコンポーネントに完全移行）
// productRecommendations.ts は削除済み（kd-product-recommendations Litコンポーネントに完全移行）
import { waitForElementAndCopy } from './productVariant';
import { ProductCartItem } from './productCartItem';

mainProduct();

mainProductCartButton();

// send Yappli event
sendYappliEvent('content_view', {
  price: Shopify.product.price.toString(),
  content_id: `${Shopify.product.id.toString()}-${Shopify.product.variant.id.toString()}`,
  content_type: Shopify.product.type,
  currency: 'JPY',
});

// androidはVerdanaがインストールされていないので別で調整
const isAndroid = navigator.userAgent.indexOf('Android') > 0;
if (isAndroid) {
  const perOffBadge = document.querySelector('div.product-detail__border > div > div > span') as HTMLElement;
  if (perOffBadge) {
    perOffBadge.style.letterSpacing = '0.05em';
    perOffBadge.style.left = '11px';
  }
}

// product__description fixed のクラスを持つdivクラスが画面の下から25%の位置に来たらfixedを解除する
const description = document.querySelector('.product__description.fixed') as HTMLElement;
if (description) {
  window.addEventListener('scroll', () => {
    const rect = description.getBoundingClientRect();
    const bottom = window.innerHeight * 0.75;
    if (rect.top < bottom && description.classList.contains('fixed')) {
      description.classList.remove('fixed');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const productCart = new ProductCartItem(document);
  productCart.initialize();
});

async function copyDynamicNode() {
  try {
    await waitForElementAndCopy('huckleberry-subscription-widget-container', 'huckleberry-subscription-widget-clone');
  } catch {
    // no subscription widget
  }
}
copyDynamicNode();
